export default __webpack_public_path__ + "static/media/cup.8b126bff.svg";